export default __webpack_public_path__ + "static/media/PackageUpgrade.af0204f0.svg";